import React from 'react';

/**
 * Reusable StatusBadge Component
 * 
 * @param {Object} props
 * @param {string} props.status - Status value
 * @param {string} props.variant - Custom variant override
 * @param {string} props.className - Additional classes
 */
const StatusBadge = ({ status, variant, className = '' }) => {
  const toTitleCase = (value) => {
    if (value === null || value === undefined) return '';

    const str = String(value)
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    if (!str) return '';

    return str
      .split(' ')
      .map((word) => (word ? word[0].toUpperCase() + word.slice(1).toLowerCase() : ''))
      .join(' ');
  };

  const getStatusConfig = (statusValue) => {
    const configs = {
      //green
      active: { bg: 'bg-green-100', text: 'text-green-700', label: 'Active' },
      approved: { bg: 'bg-green-100', text: 'text-green-700', label: 'Approved' },
      submitted: { bg: 'bg-green-100', text: 'text-green-700', label: 'Submitted' },

      //purple
      endorsed: { bg: 'bg-purple-100', text: 'text-purple-700', label: 'Endorsed' },

      //yellow
      pending: { bg: 'bg-yellow-100', text: 'text-yellow-700', label: 'Pending' },

      //blue 
      under_review: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Under Review' },

      //red
      rejected: { bg: 'bg-red-100', text: 'text-red-700', label: 'Rejected' },
      suspended: { bg: 'bg-red-100', text: 'text-red-700', label: 'Suspended' },

      //gray
      expired: { bg: 'bg-gray-100', text: 'text-gray-700', label: 'Expired' },
      inactive: { bg: 'bg-gray-100', text: 'text-gray-700', label: 'Inactive' },
      closed: { bg: 'bg-gray-100', text: 'text-gray-700', label: 'Closed' },
    };

    const normalizedKey = statusValue ? String(statusValue).trim().toLowerCase() : '';
    const fallbackLabel = toTitleCase(statusValue) || '';

    return configs[normalizedKey] || { bg: 'bg-gray-100', text: 'text-gray-700', label: fallbackLabel };
  };

  const config = variant 
    ? { bg: variant.split(' ')[0], text: variant.split(' ')[1] || '', label: toTitleCase(status) || '' }
    : getStatusConfig(status);

  return (
    <span
      className={`inline-flex px-2 py-1 text-center text-xs font-semibold rounded-full ${config.bg} ${config.text} ${className}`}
    >
      {config.label}
    </span>
  );
};

export default StatusBadge;
